module.exports = __webpack_public_path__ + "static/media/avatar.cf24fb95.svg";